"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const __1 = require("..");
const OMUniverse_1 = __importDefault(require("../OMUniverse"));
// Array.flapMap shim https://github.com/Microsoft/TypeScript/issues/31015
Array.prototype.flatMap = Array.prototype.flatMap || function (f, that) {
    const ys = [];
    this.forEach((x, i, xs) => {
        const y = f.call(that, x, i, xs);
        Array.isArray(y) ? ys.push(...(y)) : ys.push(y);
    });
    return ys;
};
class OMRestApiClient {
    constructor({ baseURL = OMUniverse_1.default.shared.baseURL, applicationKey = OMUniverse_1.default.shared.applicationKey, installation = OMUniverse_1.default.shared.installation, session = OMUniverse_1.default.shared.session, } = {}) {
        this.requestHeaders = {};
        const headers = {
            "Accept": "application/vnd.api+json",
            /* Caveat: axios will remove Content-Type header if request is sent without body */
            "Content-Type": "application/vnd.api+json",
        };
        if (OMUniverse_1.default.shared.session) {
            headers.Authorization = `Bearer ${session.token}`;
        }
        if (OMUniverse_1.default.shared.applicationKey) {
            headers["X-Harbour-Application-Key"] = applicationKey;
        }
        if (OMUniverse_1.default.shared.installation) {
            headers["X-Harbour-Installation"] = installation.id;
        }
        this.api = axios_1.default.create({
            baseURL: baseURL,
            headers,
        });
    }
    /* METHOD: OMApiClientProtocol */
    send(config) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (config.url &&
                    OMUniverse_1.default.shared.session &&
                    OMUniverse_1.default.shared.session.isRenewable &&
                    OMUniverse_1.default.shared.session.shouldRenewAt.isSameOrBefore(new Date()) &&
                    // not installation related check
                    !(config.url.split("/")[0] === "installations" &&
                        (config.method === "POST" || config.method === "PATCH")) &&
                    // not extending or renewing session check
                    !(config.url.split("/")[0] === "sessions" &&
                        (config.url.split("/").includes("renew") || config.url.split("/").includes("extend")) &&
                        config.method === "POST")) {
                    yield new Promise((resolve) => setTimeout(resolve, 0));
                    if (OMUniverse_1.default.shared.extendOrRenewSessionPromise) {
                        yield OMUniverse_1.default.shared.extendOrRenewSessionPromise;
                    }
                    else {
                        yield OMUniverse_1.default.shared.extendOrRenewSession();
                    }
                    return OMUniverse_1.default.shared.apiClient.send(config);
                }
                switch (config.method) {
                    case "GET":
                    case "DELETE":
                        // Pass in empty data to workaround axios removing Content-Type headers
                        return yield this.api.request(Object.assign({}, config, { data: {} }));
                    case "POST":
                    case "PATCH":
                    case "PUT":
                        return yield this.api.request(config);
                    default:
                        throw new Error("Future implementation");
                }
            }
            catch (error) {
                if (error &&
                    error.response &&
                    error.response.data &&
                    error.response.data.errors &&
                    error.response.data.errors[0] &&
                    (error.response.data.errors[0].title === "Session Expired" &&
                        error.response.data.errors[0].detail === "Your session has expired.")) {
                    // Time-drift detected
                    // Attemp to recalculate time-drift by calling renew
                    if (OMUniverse_1.default.shared.session) {
                        yield OMUniverse_1.default.shared.session.renew();
                    }
                    return this.send(config);
                }
                else {
                    if (error &&
                        error.response &&
                        error.response.data &&
                        error.response.data.errors &&
                        error.response.data.errors[0] &&
                        error.response.data.errors[0].title === "Invalid Installation" &&
                        error.response.data.errors[0].detail.includes("is not a valid Installation ID")) {
                        OMUniverse_1.default.shared.clearUserSession();
                        OMUniverse_1.default.shared.installation = undefined;
                        OMUniverse_1.default.shared.removeCookie("installation");
                        if (typeof document !== "undefined") {
                            document.location.reload();
                        }
                    }
                    if (error &&
                        error.response &&
                        error.response.data &&
                        error.response.data.errors &&
                        error.response.data.errors[0] &&
                        ((error.response.data.errors[0].title === "Session Blacklisted" &&
                            error.response.data.errors[0].detail === "Session token blacklisted.") ||
                            error.response.data.errors[0].detail === "jwt expired")) {
                        OMUniverse_1.default.shared.clearUserSession();
                        if (typeof document !== "undefined") {
                            document.location.reload();
                        }
                    }
                    throw error;
                }
            }
        });
    }
    objectsFromResponse(ObjectType, response) {
        const objects = __1.JsonUtils.transformObject(response);
        return objects.map((object) => new ObjectType(object));
    }
}
OMRestApiClient.kRestApiErrorDomain = "RestApiClient";
OMRestApiClient.kRestApiErrorCodeKey = "RestAPIErrorCode";
exports.default = OMRestApiClient;
//# sourceMappingURL=OMRestApiClient.js.map